import { create } from 'zustand';

import { IContextState, IInitialState } from './interfaces';

// Empty means "UE has not told us yet" — the element keeps the cursor the
// browser gives it. Only a reported state ever writes a value, so a build with
// the CURSOR_STATE_UE flag off behaves exactly as it did before MV-1820.
const initialState: IInitialState = {
  cursor: '',
};

/**
 * Cursor UE asks for over the stream (MV-1820).
 *
 * Lives in a store rather than in a provider because the element the stream
 * renders into is a sibling of `MytaverseEventProvider` in `EventPageContainer`,
 * so the websocket handler that receives the state and the element that displays
 * it are in two separate React trees.
 *
 * Provider-agnostic on purpose (MV-2116): the state describes the viewport, not
 * one streaming SDK. It used to live under `VideoGameCast/` and was named after
 * GameLift Streams, which is why the state kept being written to the GameLift
 * video tag long after `MYTA_STREAMS` became the element the user actually looks
 * at. Every provider reads the same store now — GameCast renders the cursor
 * through React (`VideoGamecast`), the PixelStreaming ones through
 * `useApplyStreamCursor`, because there the `<video>` belongs to the library.
 */
export const useStreamCursor = create<IContextState>((set) => ({
  ...initialState,
  setCursor: (cursor) => set({ cursor }),
  resetState: () => set(initialState),
}));
